import Axios from "@/plugins/Axios";

export class AtendimentosService {
  async syncAll(query = null) {
    const response = await Axios().get("atendimentos", { params: { query } });

    return response.data;
  }

  async find(id) {
    const response = await Axios().get(`atendimentos/${id}`);

    return response.data;
  }

  async criar(payload) {
    const response = await Axios().post("atendimentos", payload);

    return response.data;
  }

  async atualizar(id, payload) {
    const response = await Axios().put(`atendimentos/${id}`, payload);

    return response.data;
  }

  async deletar(atendimento) {
    const response = await Axios().delete(`atendimentos/${atendimento.id}`);

    return response.data;
  }

  async confirmar(id) {
    const response = await Axios().post(`atendimentos/${id}/confirmar`);

    return response.data;
  }

  async imprimir(id) {
    const response = await Axios().get(`atendimentos/${id}/imprimir`, {
      responseType: "arraybuffer",
    });
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  async anexarCertificado(id, file) {
    const formData = new FormData();
    formData.append("certificado", file);
    const response = await Axios().post(`atendimentos/${id}/certificado`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  }

  async baixarCertificado(id) {
    const response = await Axios().get(`atendimentos/${id}/certificado/download`, {
      responseType: "arraybuffer",
    });
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `certificado-atendimento-${id}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  async buscarMatriculas(query = null, configuracaoId = null) {
    const response = await Axios().get("atendimentos/matriculas-para-frequencia", {
      params: { query, configuracao_id: configuracaoId },
    });

    return response.data;
  }
}

export default new AtendimentosService();
